import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
	MessageModule,
	InputTextModule,
	MessagesModule,
	ToolbarModule,
	ProgressBarModule,
	ProgressSpinnerModule,
	ConfirmDialogModule,
	DialogModule,
	CalendarModule,
	DropdownModule,
	InputTextareaModule,
	MultiSelectModule,
	ToggleButtonModule,
	AutoCompleteModule,
	SpinnerModule,
	FieldsetModule,
	PanelModule,
	FileUploadModule,
	TabViewModule,
	AccordionModule,
	StepsModule,
	TabMenuModule,
	InputSwitchModule,
	ChartModule,
	EditorModule
} from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { DynamicDialogModule } from 'primeng/components/dynamicdialog/dynamicdialog';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { VarDirective } from './directives/ng-var.directive';
import { SafePipe } from './pipes/safe.pipe';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MessageModule,
		InputTextModule,
		MessagesModule,
		ToolbarModule,
		ProgressBarModule,
		TableModule,
		ProgressSpinnerModule,
		ConfirmDialogModule,
		DialogModule,
		CalendarModule,
		DropdownModule,
		InputTextareaModule,
		MultiSelectModule,
		ToggleButtonModule,
		AutoCompleteModule,
		DynamicDialogModule,
		SpinnerModule,
		FieldsetModule,
		PanelModule,
		FileUploadModule,
		TabViewModule,
		AccordionModule,
		StepsModule,
		TabMenuModule,
		InputSwitchModule,
		ChartModule,
		EditorModule
	],
	declarations: [ DocumentUploadComponent, VarDirective, SafePipe ],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MessageModule,
		InputTextModule,
		MessagesModule,
		ToolbarModule,
		ProgressBarModule,
		TableModule,
		ProgressSpinnerModule,
		ConfirmDialogModule,
		DialogModule,
		CalendarModule,
		DropdownModule,
		InputTextareaModule,
		MultiSelectModule,
		ToggleButtonModule,
		AutoCompleteModule,
		DynamicDialogModule,
		SpinnerModule,
		FieldsetModule,
		PanelModule,
		FileUploadModule,
		TabViewModule,
		AccordionModule,
		StepsModule,
		TabMenuModule,
		InputSwitchModule,
		ChartModule,
		EditorModule,
		DocumentUploadComponent,
		VarDirective,

		SafePipe
	],
	providers: [],
	entryComponents: [ DocumentUploadComponent ]
})
export class SharedModule {}
